import { useState } from "react";
import { FiChevronDown, FiLogOut, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router";

const Header = () => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    navigate("/login");
  };

  // Get user name from localStorage or use default
  const userName = localStorage.getItem("userName") || "Admin";

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200" style={{ height: '61px' }}>
      <div className="flex items-center justify-between w-full h-full">
        {/* Left: Brand Identity */}
        <div className="flex items-center px-6 h-full bg-white">
          {/* Brand Name - Script Font */}
          <span 
            className="text-gray-800 text-2xl font-normal"
            style={{ 
              fontFamily: "'Brush Script MT', 'Lucida Handwriting', cursive",
              fontStyle: 'italic',
              letterSpacing: '0.5px'
            }}
          >
            
          </span>
        </div>

        {/* Right: User Profile */}
        <div className="flex items-center px-6 h-full">
          <div className="relative">
            <button
              onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
              className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 transition-colors"
            >
              <span className="text-sm font-medium text-gray-800">{userName}</span>
              <FiChevronDown
                size={14}
                className={`text-gray-600 transition-transform ${isUserMenuOpen ? "rotate-180" : ""}`}
              />
              {/* User Initial Avatar */}
              <div className="h-7 w-7 rounded-full bg-gray-200 flex items-center justify-center">
                <span className="text-xs font-semibold text-gray-700">
                  {userName.charAt(0).toUpperCase()}
                </span>
              </div>
            </button>

            {/* Dropdown Menu */}
            {isUserMenuOpen && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setIsUserMenuOpen(false)}
                ></div>
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <button
                    onClick={() => {
                      setIsUserMenuOpen(false);
                      // Navigate to profile if needed
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    <FiUser size={16} />
                    Profile
                  </button>
                  <div className="border-t border-gray-100 my-1"></div>
                  <button
                    onClick={() => {
                      setIsUserMenuOpen(false);
                      handleLogout();
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  >
                    <FiLogOut size={16} />
                    Logout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

